/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, forwardRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import ClearScripts from '@mummssoftware/clearscripts';
import CarePlanFrequency from '@mummssoftware/care-plan-frequency';
import CarePlanProblems from '@mummssoftware/care-plan-problems';
import CertApp from '@mummssoftware/cert-app';
import ManifestWidget from '@mummssoftware/manifest';
import Facesheet from '@mummssoftware/facesheet';
import Forms from '@mummssoftware/forms';
import Measures from '@mummssoftware/measures';
import HospiceItemSet from '@mummssoftware/hospice-item-set';
import Hope from '@mummssoftware/hope';
import PatientAssistance from '@mummssoftware/patient-assistance';
import Bereavement from '@mummssoftware/bereavement';
import ProgressNotes from '@mummssoftware/progressnotes';
import IDGDocument from '@mummssoftware/idg-document';
import { CertGlobalContext } from '@mummssoftware/global-context';
import { IDGGlobalContext } from '@mummssoftware/idg';
import ReportsList from '@mummssoftware/reports-list';
import {
  PrintPreviewHeader,
  PrintPreviewFooter,
  DashboardCoverPage,
} from '@mummssoftware/common-ui/PagedJS';
import { Manifest } from '@mummssoftware/utils/constants';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import { ComponentMap } from '../Context/types';
import { SET_DISABLE_PRINT, ADD_WIDGET_READY } from '../Context/constants';
import { DashboardPrintDiv } from '../../components';
import { Context } from '../../context';
import { DashboardContext } from '../Context/contexts/DashboardContext';

import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

type ContainerType = {
  count?: string; /// Passing Optional Props
};

const StyledDiv = styled.div<ContainerType>`
  --count: ${(props) => props.count};
  margin-top: calc(var(--count) + 5px);
  @media print {
    transform: scale(0.95);
  }
`;

type DashboardPrintProps = {
  dashboardPrintConfig: mumms.PrintConfigInterface;
  printConfigNames: Record<mumms.ComponentName, string>;
};
type fwdRef = React.MutableRefObject<any> | React.Ref<any>;

export const DashboardPrintComponent = forwardRef(
  (
    { dashboardPrintConfig, printConfigNames }: DashboardPrintProps,
    ref: fwdRef,
  ) => {
    const mainPrintConfig = dashboardPrintConfig && {
      ...dashboardPrintConfig,
    };
    // fromDate & toDate interval needed
    //! DATE FORMAT IS IMPORTANT! Safari doesn't like slash separated dates.
    // formatting to forward slash should happen at UI level
    const fromDate = dashboardPrintConfig && dashboardPrintConfig.fromDate;
    const toDate = dashboardPrintConfig && dashboardPrintConfig.toDate;
    /*
      Converted the fromDate and twoDate back to strings.  The MM-DD-YYYY
      is required for observation service to process the incoming request. 
    */
    const printDateConfig: any =
      fromDate && toDate
        ? {
            fromDate: moment(fromDate[0]).format('MM-DD-YYYY'),
            toDate: moment(toDate[0]).format('MM-DD-YYYY'),
          }
        : {};

    const printConfigState = Object.entries({
      ...dashboardPrintConfig,
    }).reduce((seed: any, printWidget: any) => {
      const name = printWidget[0];
      const config = printWidget[1];
      const printConfig =
        typeof config === 'boolean'
          ? printDateConfig
          : { ...printDateConfig, ...config };
      seed[name] = printConfig;
      return seed;
    }, {});

    // delete those 2 keys to get the generatePrintGrid array
    mainPrintConfig && delete mainPrintConfig?.fromDate;
    mainPrintConfig && delete mainPrintConfig?.toDate;
    const printWidgetConfig: mumms.PrintWidgetConfigInterface = mainPrintConfig && {
      ...mainPrintConfig,
    };

    // widgetConfig is array of componentName to generatePrintGrid
    const widgetConfig: string[] | null = printWidgetConfig
      ? Object.keys(printWidgetConfig).filter(
          (key) => (printWidgetConfig as any)[key],
        )
      : null;

    const { pim, keycloak, currentUser, patient, agency } = useContext(Context);

    const { patientCertHistory } = useContext(CertGlobalContext);
    const { idgContent, allIdgQuestionnaires } = useContext(IDGGlobalContext);
    const { dispatch } = useContext(DashboardContext);
    const patientNumber = patient && patient.patientNumber;
    const getComponent = ({ name, title }: mumms.GetCompProps) =>
      Map[name] &&
      (Map[name] as any)({
        title,
      });

    /* generic widget callback implementation */
    const onWidgetReady = (widgetName: mumms.ComponentName) => {
      if (widgetName) {
        if (dispatch) {
          dispatch({
            type: ADD_WIDGET_READY,
            payload: widgetName,
          });
        }
      }
    };

    // Currently, we are only disabling the print button if the manifest is still
    // rendering.  This setManifestReady function is passed down to the manifest so that
    // once manifest has finished rendering all requested HTMLs for the date range, we
    // then set the print icon to active.
    // Note:  if printContext.view is "Listing", then this state will be updated as soon
    // as manifest loads.
    const [manifestReady, setManifestReady] = useState<boolean>(false);

    useEffect(() => {
      if (manifestReady) {
        // if manifest is not ready, then diable the icon by setting the payload to true
        // ortherwise, enable the icon by setting the payload to false.
        dispatch({
          type: SET_DISABLE_PRINT,
          payload: !manifestReady,
        });
      }
    }, [manifestReady]);

    // If the manifest was not selected in print da chart, no need to disable the icon.
    // Set Manifest to ready here since the manifest widget would not be rendered otherwise.
    if (widgetConfig && !widgetConfig.includes(Manifest) && !manifestReady) {
      setManifestReady(true);
    }

    const viewMode: mumms.viewMode = 'print';

    const Map: ComponentMap = {
      DocLink: () => (
        <CertApp
          agency={agency || undefined}
          keycloak={keycloak}
          patientNumber={patientNumber}
          viewMode={viewMode}
          onWidgetReady={onWidgetReady}
          key={dashboardPrintConfig ? 'DocLink' : 'print'}
          printConfig={printConfigState.DocLink}
        />
      ),
      CarePlanFrequency: ({ title }: mumms.MapProps) => (
        <ErrorBoundary>
          <CarePlanFrequency
            appTitle={title}
            agency={agency || undefined}
            currentUser={currentUser}
            embedded
            keycloak={keycloak}
            online
            patient={patient}
            patientNumber={patientNumber}
            pim={pim}
            smallWidget
            view={undefined}
            key={dashboardPrintConfig ? 'CarePlanFrequency' : 'print'}
            viewMode={viewMode}
            onWidgetReady={onWidgetReady}
            printConfig={printConfigState.CarePlanFrequency}
          />
        </ErrorBoundary>
      ),
      ClearScripts: ({ title }: mumms.MapProps) => (
        <ErrorBoundary>
          <ClearScripts
            appTitle={title}
            agency={agency || undefined}
            currentUser={currentUser}
            dashboardEmbedded
            embedded
            hideActionBar
            keycloak={keycloak}
            online
            patient={patient}
            patientNumber={patientNumber}
            key={dashboardPrintConfig ? 'ClearScripts' : 'print'}
            viewMode={viewMode}
            onWidgetReady={onWidgetReady}
            printConfig={printConfigState.ClearScripts}
          />
        </ErrorBoundary>
      ),
      Facesheet: ({ title }: mumms.MapProps) => (
        <ErrorBoundary>
          <Facesheet
            appTitle={title as string}
            agency={agency}
            keycloak={keycloak}
            online
            patientNumber={patientNumber}
            key={dashboardPrintConfig ? 'Facesheet' : 'print'}
            viewMode={viewMode}
            onWidgetReady={onWidgetReady}
          />
        </ErrorBoundary>
      ),
      Forms: ({ title }: mumms.MapProps) => (
        <ErrorBoundary>
          <Forms
            appTitle={title as string}
            agency={agency}
            currentUser={currentUser}
            embedded
            keycloak={keycloak}
            patientNumber={patientNumber}
            patient={patient}
            pim={pim}
            key={dashboardPrintConfig ? 'Forms' : 'print'}
            database={null}
          />
        </ErrorBoundary>
      ),
      Manifest: ({ title }: mumms.MapProps) => (
        <ErrorBoundary>
          <ManifestWidget
            appTitle={title as string}
            agency={agency}
            embedded
            keycloak={keycloak}
            patientNumber={patientNumber}
            currentUser={currentUser}
            patient={patient}
            key={dashboardPrintConfig ? 'Manifest' : 'print'}
            viewMode={viewMode}
            printConfig={printConfigState.Manifest}
            onWidgetReady={onWidgetReady}
            onFinishedPrinting={setManifestReady}
          />
        </ErrorBoundary>
      ),
      Measures: ({ title }: mumms.MapProps) => (
        <ErrorBoundary>
          <Measures
            appTitle={title}
            agency={agency}
            currentUser={currentUser}
            embedded
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            pim={pim as any}
            key={dashboardPrintConfig ? 'Measures' : 'print'}
            viewMode={viewMode}
            onWidgetReady={onWidgetReady}
            printConfig={printConfigState.Measures}
          />
        </ErrorBoundary>
      ),
      HospiceItemSet: ({ title }: mumms.MapProps) => (
        <ErrorBoundary>
          <HospiceItemSet
            embedded
            online
            appTitle={title}
            agency={agency}
            currentUser={currentUser}
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            pim={pim as any}
          />
        </ErrorBoundary>
      ),
      Hope: ({ title, watermark, onClick, smallWidget }: mumms.MapProps) => (
        <ErrorBoundary>
          <Hope
            embedded
            online
            smallWidget={smallWidget}
            appTitle={title}
            agency={agency}
            currentUser={currentUser}
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            // TODO fix agency issue for admin
            // pim={pim}
            watermark={watermark}
            onClick={onClick}
            onWidgetReady={onWidgetReady}
          />
        </ErrorBoundary>
      ),
      ReportsList: ({
        title,
        watermark,
        onClick,
        smallWidget,
      }: mumms.MapProps) => (
        <ErrorBoundary>
          <ReportsList
            embedded
            online
            smallWidget={smallWidget}
            appTitle={title}
            agency={agency}
            currentUser={currentUser}
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            // TODO fix agency issue for admin
            // pim={pim}
            watermark={watermark}
            onClick={onClick}
            onWidgetReady={onWidgetReady}
          />
        </ErrorBoundary>
      ),
      ProgressNotes: () => (
        <ErrorBoundary>
          <ProgressNotes
            online
            agency={agency || undefined}
            embedded
            keycloak={keycloak}
            patientNumber={patientNumber}
            currentUser={currentUser}
            patient={patient}
            viewMode={viewMode}
            onWidgetReady={onWidgetReady}
            printConfig={printConfigState.ProgressNotes}
          />
        </ErrorBoundary>
      ),
      PatientAssistance: () => (
        <ErrorBoundary>
          <PatientAssistance
            online
            agency={agency || undefined}
            embedded
            keycloak={keycloak}
            patientNumber={patientNumber}
            currentUser={currentUser}
            patient={patient}
            viewMode={viewMode}
            onWidgetReady={onWidgetReady}
            printConfig={printConfigState.PatientAssistance}
          />
        </ErrorBoundary>
      ),
      CarePlanProblems: () => (
        <ErrorBoundary>
          <CarePlanProblems
            agency={agency || undefined}
            currentUser={currentUser}
            embedded
            pim={pim}
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            onWidgetReady={onWidgetReady}
            printConfig={printConfigState.CarePlanProblems}
            viewMode={viewMode}
          />
        </ErrorBoundary>
      ),
      Bereavement: () => (
        <ErrorBoundary>
          <Bereavement
            agency={agency || undefined}
            currentUser={currentUser}
            online
            embedded
            pim={pim}
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            onWidgetReady={onWidgetReady}
            printConfig={printConfigState.Bereavement}
            viewMode={viewMode}
          />
        </ErrorBoundary>
      ),
      IDGDocument: () => (
        <ErrorBoundary>
          <IDGDocument
            agency={agency || undefined}
            online
            currentUser={currentUser}
            embedded
            pim={pim}
            keycloak={keycloak}
            patient={patient}
            patientNumber={patientNumber}
            onWidgetReady={onWidgetReady}
            printConfig={printConfigState.CarePlanProblems}
            printConfigNames={printConfigNames}
            viewMode={viewMode}
          />
        </ErrorBoundary>
      ),
    };

    const generatePrintGrid = (config: mumms.ComponentName[]) =>
      config.map((widgetName: mumms.ComponentName, i) => (
        <React.Fragment key={widgetName}>
          <StyledDiv count={`${i}px`} id={widgetName}>
            {getComponent({
              title: printConfigNames[widgetName],
              name: widgetName,
            })}
          </StyledDiv>
        </React.Fragment>
      ));

    return (
      <div ref={ref}>
        <DashboardCoverPage
          patient={patient}
          patientCertHistory={patientCertHistory}
          idgMeetingContent={idgContent}
          allIdgQuestionnaires={allIdgQuestionnaires}
          currentUser={currentUser}
        />
        <DashboardPrintDiv id="dashboard-print">
          {widgetConfig &&
            generatePrintGrid(widgetConfig as mumms.ComponentName[])}
          <PrintPreviewHeader patient={patient} />
          <PrintPreviewFooter />
        </DashboardPrintDiv>
      </div>
    );
  },
);
export default DashboardPrintComponent;
